export default __webpack_public_path__ + "static/media/sold.79007341.svg";